// I wanna add frontend route paths to this file
const Path = {
    home: '/',
    signUp: '/register',
    signIn: '/login',
    emailVerification: '/email-verification',
    forgotPassword: '/forgot-password',
    dashboard: '/dashboard',
    checkout: '/checkout',
    paymentResult: '/payment-result',
    privacyPolicy: '/privacy-policy',
    termsOfService: '/terms-of-service',
};

export default Path;